// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".link--dBJZu{color:#fff !important;text-decoration:none}.link--dBJZu:hover{text-decoration:underline}.current--wzg66{color:#fff}", "",{"version":3,"sources":["webpack://./src/gui/Apps/Customer/Pages/InstantDeals/DealDetail/DealDetailBreadcrumb.module.scss"],"names":[],"mappings":"AAAA,aAAM,qBAAqB,CAAC,oBAAoB,CAAC,mBAAY,yBAAyB,CAAC,gBAAS,UAAU","sourcesContent":[".link{color:#fff !important;text-decoration:none}.link:hover{text-decoration:underline}.current{color:#fff}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": "link--dBJZu",
	"current": "current--wzg66"
};
export default ___CSS_LOADER_EXPORT___;
